export const AdminFooter = () => {
  
  return (
    ''
  );
}